import { wrap } from 'svelte-spa-router/wrap';
import Home from './components/Home.svelte';
import NotFound from './components/NotFound.svelte';

// Lazy-loaded components
const ArticlePage = wrap({
  asyncComponent: () => import('./components/ArticlePage.svelte'),
});

const SearchPage = wrap({
  asyncComponent: () => import('./components/SearchPage.svelte'),
});

export const routes = {
  '/': Home,
  '/volumes/*': ArticlePage,
  '/wiki/*': ArticlePage,
  '/search': SearchPage,
  '*': NotFound, // 404 fallback
};
